import type { SVGProps } from 'react';
const objectMagnifyingglassTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M10.5 1.5C15.4706 1.5 19.5 5.52944 19.5 10.5C19.5 12.6991 18.7112 14.7141 17.4012 16.2773L22.3902 21.2652C22.6831 21.5581 22.6831 22.0329 22.3902 22.3258C22.1182 22.5978 21.6893 22.6172 21.3949 22.3841L21.3295 22.3258L16.3467 17.3424C14.774 18.6876 12.7318 19.5 10.5 19.5C5.52944 19.5 1.5 15.4706 1.5 10.5C1.5 5.52944 5.52944 1.5 10.5 1.5ZM10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35786 14.6421 3 10.5 3Z"
      fill={props.color ?? '#000'}
      fillRule="evenodd"
    />
  </svg>
);
export default objectMagnifyingglassTemplateOutline;
